// The pickup point map comes from the Snake address SDK module, loaded on demand.
// Note: the module publishes the factory on window.SnakeAddress, but calling it
// replaces that same global with the built api object, so keep our own reference.
let factory;
let loading;

export function loadSnakeAddress() {
  if (factory) {
    return Promise.resolve(factory);
  }
  if (typeof window.SnakeAddress === 'function') {
    factory = window.SnakeAddress;
    return Promise.resolve(factory);
  }
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = process.env.REACT_APP_SNAKE_ADDRESS_URL;
      script.onload = () => {
        if (typeof window.SnakeAddress === 'function') {
          factory = window.SnakeAddress;
          resolve(factory);
        } else {
          reject(new Error('SnakeAddress not available'));
        }
      };
      script.onerror = () => reject(new Error('Cannot load ' + script.src));
      document.body.appendChild(script);
    }).catch((err) => {
      loading = undefined;
      throw err;
    });
  }
  return loading;
}
